__turbopack_context__.v({
  "caption": "PrototypeClip-module-scss-module__W0Wc8G__caption",
  "clip": "PrototypeClip-module-scss-module__W0Wc8G__clip",
  "frame": "PrototypeClip-module-scss-module__W0Wc8G__frame",
  "wide": "PrototypeClip-module-scss-module__W0Wc8G__wide",
});
